import styled, { css } from 'styled-components';

// Import styles
import { customMinResponsive, size } from 'components/styles';

type Props = {
	isSmall: boolean;
};

export const StyledImage = styled.img<Props>`
	width: 100%;
	object-fit: contain;
	border-radius: 2rem;

	${customMinResponsive(
		size.semi,
		css<Props>`
			width: ${({ isSmall }) => (isSmall ? 20 : 25)}%;
		`
	)}
`;
